module.exports = __webpack_public_path__ + "img/dc_wx.png";